import React, { createContext, useState } from 'react';

export const SearchContext = createContext({
  searchVisiblity: false,
  changeSearchVisiblity: () => {},
  workspacesOnly: false,
  setWorkspacesOnly: () => {},
});

export const SearchProvider = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [workspacesOnly, setWorkspacesOnly] = useState(false);

  return (
    <SearchContext.Provider
      value={{ searchVisiblity: visible, changeSearchVisiblity: setVisible, workspacesOnly, setWorkspacesOnly }}
    >
      {children}
    </SearchContext.Provider>
  );
};
